'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var common = require('./common.js');
var geoLocation_types = require('./geo-location.types.js');



exports.queryGeolocationPermission = common.queryGeolocationPermission;
Object.defineProperty(exports, 'GeoLocationProvider', {
	enumerable: true,
	get: function () {
		return geoLocation_types.GeoLocationProvider;
	}
});
Object.defineProperty(exports, 'GeoLocationReasons', {
	enumerable: true,
	get: function () {
		return geoLocation_types.GeoLocationReasons;
	}
});
